import { render } from "./CardItemSmall.vue?vue&type=template&id=7cb72a77&ts=true"
import script from "./CardItemSmall.vue?vue&type=script&lang=ts"
export * from "./CardItemSmall.vue?vue&type=script&lang=ts"

import "./CardItemSmall.vue?vue&type=style&index=0&id=7cb72a77&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__